module.exports = __webpack_public_path__ + "img/mclaren.2c1680db.jpg";